/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  hotel: 'hotel',
  destination: 'destination',
  night: 'night',
  week: 'week',
  paxSelection: 'paxSelection',
  travelDate: 'travelDate',
  hotelName: 'hotelName',
  origin: 'origin',
  submit: 'submit',
  invalidInput: 'invalidInput',
  category: 'category',
  travelers: 'travelers',
  select: 'select',
  travelTime: 'travelTime',
  adjustSearch: 'adjustSearch',
  nights: 'nights',
  duration: 'duration',
  travelDuration: 'travelDuration',
  arbitrary: 'arbitrary',
  date: 'date',
  pricePerPerson: 'pricePerPerson',
  dateAndDuration: 'dateAndDuration',
  allAirports: 'allAirports',
  apply: 'apply',
  directFlightsOnly: 'directFlightsOnly',
  errorMessageTitle: 'errorMessageTitle',
  pleaseOnlyOneDestination: 'pleaseOnlyOneDestination',
  dateShouldBeInTheRangeOf: 'dateShouldBeInTheRangeOf',
  validationErrorMessage: 'validationErrorMessage',
  childAgeErrorMessage: 'childAgeErrorMessage',
  infantNumberMustBeLessOrEqualAdultNumber: 'infantNumberMustBeLessOrEqualAdultNumber',
  maxPaxRoomConfigurationError: 'maxPaxRoomConfigurationError'
}; export default Keys;